import React from "react";
import {
  SidebarInset,
  SidebarTrigger,
} from "../../../shadcn/components/ui/sidebar";
import LogoSvg from "../../../icons/LogoSvg";
import UserIcon from "../../../icons/UserIcon";

interface DashboardHeaderProps {
  userNameLabel: string;
  userEmailLabel: string;
}

export default function DashboardHeader({
  userNameLabel,
  userEmailLabel,
}: DashboardHeaderProps) {
  return (
    <header className="h-[70px] flex items-center py-5 shrink-0 gap-2 bg-white border-b-[1px] border-l-[1px] border-[#EEE]">
      <div className="w-full flex items-center gap-2 px-4 lg:px-8">
        <SidebarTrigger className="-ml-1 lg:hidden" />
        <div className="pl-4 md:hidden flex justify-between w-full items-center">
          <LogoSvg />
          <div className="flex items-center gap-2 min-w-0">
            <div className="p-2 rounded-full bg-[#eee]">
              <UserIcon width={19} height={19} />
            </div>
            <div className="font-openSans text-xs min-w-0 max-w-[150px]">
              <div
                className="font-openSans text-brand-textBlack tracking-wider truncate"
                title={userNameLabel}
              >
                {userNameLabel}
              </div>
              <div
                className="text-brand-borderGrey text-xs truncate"
                title={userEmailLabel}
              >
                {userEmailLabel}
              </div>
            </div>
          </div>
        </div>
        <div className="w-full hidden md:flex gap-4 justify-between items-center pl-2">
          <div className="min-w-0">
            <p className="text-sm text-brand-textGrey">Welcome back</p>
            <p
              className="text-sm font-semibold text-brand-textBlack truncate max-w-[320px]"
              title={userNameLabel}
            >
              {userNameLabel || "User"}
            </p>
          </div>
          <div className="flex gap-2 min-w-0 max-w-[280px]">
            <div className="p-1 rounded-full bg-[#eee]">
              <UserIcon width={24} height={24} />
            </div>
            <div className="font-openSans text-xs min-w-0">
              <div
                className="font-openSans text-brand-textBlack tracking-wider truncate"
                title={userNameLabel}
              >
                {userNameLabel}
              </div>
              <div
                className="text-brand-borderGrey text-xs truncate"
                title={userEmailLabel}
              >
                {userEmailLabel}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
